'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _siteShape = require('./siteShape');

var _siteShape2 = _interopRequireDefault(_siteShape);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var libraryShape = _reactImmutableProptypes2.default.contains({
  getCardLink: _react.PropTypes.string,
  showHoldCountInSearch: _react.PropTypes.bool,
  showDueDateInCirc: _react.PropTypes.bool,
  siteId: _react.PropTypes.string,
  domain: _react.PropTypes.string,
  showCallNumber: _react.PropTypes.bool,
  numericPasswordRequired: _react.PropTypes.bool,
  shortName: _react.PropTypes.string,
  longName: _react.PropTypes.string,
  showVolumeSelectorStatus: _react.PropTypes.bool,
  singleBranch: _react.PropTypes.bool,
  showExternalSearchLink: _react.PropTypes.bool,
  logo: _react.PropTypes.string,
  featuredContentBlockPosition: _react.PropTypes.number,
  showVolumeSelectorDueDate: _react.PropTypes.bool,
  showInactiveHolds: _react.PropTypes.bool,
  featuredListTypes: _react.PropTypes.bool,
  showCallNumberForDigital: _react.PropTypes.bool,
  showVolumeSelectorCollection: _react.PropTypes.bool,
  pickupLocationEditable: _react.PropTypes.bool,
  libraryId: _react.PropTypes.number,
  showCollectionInCirc: _react.PropTypes.bool,
  recentlyReturned: _react.PropTypes.bool,
  cmsEnabled: _react.PropTypes.bool,
  holdInfoMessages: _reactImmutableProptypes2.default.list,
  onlyShowEditionsForCDROMAndVideoGames: _react.PropTypes.bool,
  fullName: _react.PropTypes.string,
  type: _react.PropTypes.string,
  id: _react.PropTypes.number,
  hideCallNumberForHigherSearchScope: _react.PropTypes.bool,
  linkableLibraries: _reactImmutableProptypes2.default.listOf(_siteShape2.default)
});

exports.default = libraryShape;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/bc-prop-types/lib/components/libraryShape.js
// module id = 358
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15